import React from 'react';
import './Team.css';

function Team() {
  return (
    <div id="team" className="team-main bgt">
      <h1> This is the team section</h1>
    </div>
  );
}

export default Team;
